import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import LayoutProvider from '../LayoutContext';

import CartFlyout from '../../components/CartFlyout';
import Footer from '../Footer';
import Header from '../Header';
import UKModal from '../../components/UKModal';
import StudioFinderForm from '../../components/Forms/StudioFinderFormV2';
import AlertModal from '../../components/AlertModal';

const ns = `layout-default`;

const DefaultLayout = ({ children, location }) => {
	const [isBlank, setBlank] = useState(true);

	useEffect(() => {
		function gtag() { window.dataLayer.push(arguments); } // eslint-disable-line
		window.gtag = gtag;
	}, []); // eslint-disable-line

	useEffect(() => {
		const unbxdAutoSuggestScript = document.createElement('script');
		const unbxdAutoSuggestLink = document.createElement('link');

		unbxdAutoSuggestScript.src = process.env.GATSBY_UNBXD_AUTOSUGGEST_SCRIPT;
		unbxdAutoSuggestScript.type = 'text/javascript';
		unbxdAutoSuggestScript.defer = true;
		unbxdAutoSuggestLink.rel = 'stylesheet';
		unbxdAutoSuggestLink.href = process.env.GATSBY_UNBXD_AUTOSUGGEST_CSS_LINK;

		document.head.appendChild(unbxdAutoSuggestScript);
		document.head.appendChild(unbxdAutoSuggestLink);

		// Cleanup function to remove the script when the component unmounts
		return () => {
			document.head.removeChild(unbxdAutoSuggestScript);
			document.head.removeChild(unbxdAutoSuggestLink);
		};
	}, []);

	useEffect(() => {
		if (!(location.pathname === '/account/logout/' || location.pathname === '/account/signup/' || location.pathname === '/account/login/')) {
			setBlank(() => false);
		}
	}, [location.pathname]);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--blank`]: isBlank,
	});

	return (
		<LayoutProvider>
			<div className={rootClassnames}>
				<Header pathname={location.pathname} />
				<main>
					{children}
				</main>
				<Footer />
			</div>
			<CartFlyout />
			<UKModal />
			<StudioFinderForm />
			<AlertModal positionRight={!location?.pathname.includes('account')} />
		</LayoutProvider>
	);
};

export default DefaultLayout;
